import { motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import indiaGeo from "../../../Maps/india_state.geojson"
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker
} from "react-simple-maps";

const stats = [
  { label: "Active Field Units", value: 1500, suffix: "+" },
  { label: "States Covered", value: 28, suffix: "+" },
  { label: "Avg Activation Time", value: 30, suffix: " min" },
  { label: "Cases Managed", value: 1000, suffix: "+" }
];

function Counter({ value, suffix }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (!isInView) return;

    let start = 0;
    const duration = 2000;
    const step = value / (duration / 16);

    const timer = setInterval(() => {
      start += step;
      if (start >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isInView, value]);

  return (
    <div ref={ref}>
      <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#21A6E9] to-indigo-500 bg-clip-text text-transparent">
        {count}{suffix}
      </div>
    </div>
  );
}

export default function OperationalNetwork() {
  return (
    <section className="relative py-32 px-6 bg-gradient-to-b from-[#0F172A] to-[#0C1222] text-white overflow-hidden">

      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-6xl font-semibold">
            Built Across India.
            <br />
            <span className="bg-gradient-to-r from-[#21A6E9] to-indigo-500 bg-clip-text text-transparent">
              Connected in Real Time.
            </span>
          </h2>

          <p className="mt-6 text-slate-400 max-w-2xl mx-auto">
            Structured nationwide coordination across highways,
            cities and industrial corridors.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-20 items-center">

          {/* LEFT — Stats */}
          <div className="grid grid-cols-2 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.15 }}
                viewport={{ once: true }}
                className="bg-[#111827]/70 backdrop-blur-xl border border-[#1F2937] rounded-2xl p-8 hover:border-[#21A6E9]/40 transition"
              >
                <Counter value={stat.value} suffix={stat.suffix} />
                <p className="mt-3 text-slate-400 text-sm">
                  {stat.label}
                </p>
              </motion.div>
            ))}
          </div>

          {/* RIGHT — Premium India Map */}
          <div className="relative">

            {/* Glow Behind Map */}
            <div className="absolute inset-0 bg-[#21A6E9] blur-[180px] opacity-10 rounded-full" />

         <ComposableMap
  projection="geoMercator"
  projectionConfig={{
    scale: 1000,
    center: [82, 22]
  }}
  className="w-full"
>
  <Geographies geography={indiaGeo}>
    {({ geographies }) =>
      geographies.map((geo) => (
        <Geography
          key={geo.rsmKey}
          geography={geo}
          style={{
            default: {
              fill: "#1E293B",
              stroke: "#334155",
              strokeWidth: 0.6,
              outline: "none"
            },
            hover: {
              fill: "#1E40AF",
              stroke: "#21A6E9",
              strokeWidth: 1,
              outline: "none"
            },
            pressed: {
              fill: "#1E40AF",
              outline: "none"
            }
          }}
        />
      ))
    }
  </Geographies>

  {/* Network Nodes (Correct Way Using Marker) */}
  {[
    [77.2, 28.6],   // Delhi
    [72.8, 19.0],   // Mumbai
    [77.5, 12.9],   // Bangalore
    [80.2, 13.0],   // Chennai
    [88.3, 22.5],   // Kolkata
  ].map((coord, i) => (
    <Marker key={i} coordinates={coord}>
      <circle r={6} fill="#21A6E9">
        <animate
          attributeName="r"
          values="6;10;6"
          dur="2.2s"
          repeatCount="indefinite"
        />
      </circle>
    </Marker>
  ))}
</ComposableMap>
          </div>

        </div>

      </div>
    </section>
  );
}